import Head from 'next/head';
import { Header, Footer, Plain } from '@components';
import { Box, Flex } from '@chakra-ui/react';

export function PaymentPage() {
  return (
    <Flex direction={'column'} minH={'100vh'}>
      <Head>
        <title>
          Płatność i dostawa | IKSEL Studio Reklamy - Reklama dla Twojej firmy
        </title>

        <meta
          name="description"
          content="IKSEL Studio Reklamy - Szczegóły dotyczące płatności i rozliczeń za zamówienia. Kompleksowa obsługa reklamowa i kampanie marketingowe"
        />
      </Head>

      <Header
        id="header"
        logo={{
          imageUrl: '/images/logo_medium.png',
          href: '/',
        }}
        menu={{
          elements: [
            {
              id: 'header-strona-glowna-link',
              label: 'Strona główna',
              href: '/',
            },
            {
              id: 'header-oferta-link',
              label: 'Oferta',
              href: '/#oferta',
            },
            {
              id: 'header-aktualnosci-link',
              label: 'Aktualności',
              href: 'https://www.facebook.com/IKSEL.reklama',
            },
            {
              id: 'header-kontakt-link',
              label: 'Kontakt',
              href: '/kontakt',
            },
          ],
        }}
      />

      <Box flex={1}>
        <Plain
          id="platnosc-i-dostawa"
          title="Płatność i dostawa"
          subtitle="Śledź swoje przesyłki na bieżaco"
          html={`
            <h3>Wysyłka zam&oacute;wienia</h3>
            <p>Wszystkie zam&oacute;wienia klient&oacute;w realizujemy za pośrednictwem firmy spedycyjnej UPS. Dzięki temu jesteśmy w stanie zapewnić kompleksowe rozwiązania logistyczne dostosowane do indywidualnych potrzeb naszych klient&oacute;w. Gwarantujemy szybką i sprawną obsługę związaną z wysyłką towaru oraz optymalne koszty transportu.</p>
            <h3>Koszty</h3>
            <ul>
              <li>Koszt przesyłki wynosi 15zł bez względu na wagę przesyłki. W cenię wliczone jest ubezpieczenie paczki do kwoty wartości zam&oacute;wienia.</li>
              <li>Oferta ważna jest tylko na terenie Polski.</li>
            </ul>
            <h3>Uszkodzona paczka</h3>
              <ul>
              <li>W przypadku stwierdzenia jakichkolwiek uszkodzeń na paczce&nbsp;<u>należy sprawdzić kompletność towaru w paczce przy obecności kuriera.</u></li>
              <li>W razie stwierdzenia brak&oacute;w należy sporządzić protok&oacute;ł reklamacyjny (kurier posiada odpowiedni druk), gdyż jest to jedyna podstawa do złożenia reklamacji.</li>
            </ul>
            <p>Wszystkie wysyłane paczki są przez nas sprawdzane i dokładnie zabezpieczane. Informację na temat przesyłek mogą Państwo na bieżąco monitorować.</p>
          `}
        />
      </Box>

      <Footer
        id="footer"
        logo={{
          imageUrl: '/images/logo_medium.png',
          href: '/',
        }}
        categories={[
          {
            name: 'Zasady',
            elements: [
              {
                text: 'Polityka prywatności',
                href: '/polityka-prywatnosci',
              },
              {
                text: 'Płatność i dostawa',
                href: '/platnosc-i-dostawa',
              },
              {
                text: 'FAQ',
                href: '/faq',
              },
            ],
          },
          {
            name: 'Pomoc',
            elements: [
              {
                text: 'Jak zamawiać?',
                href: '/jak-zamawiac',
              },
              {
                text: 'Akceptowalne pliki',
                href: '/akceptowalne-pliki',
              },
              {
                text: 'Projektowanie',
                href: '/projektowanie',
              },
            ],
          },
        ]}
      />
    </Flex>
  );
}

export default PaymentPage;
